import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import RightDoubleArrow from '@mui/icons-material/DoubleArrow'
import { Box, Card, IconButton, styled, Typography } from '@mui/material'
import { MouseEventHandler } from 'react'

const MyTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  padding: 10,
}))
const MyButton = styled(IconButton)({
  display: 'flex',
  alignItems: 'center',
  '& .MuiTypography-root': { marginLeft: 3 },
})

const TopDoubleArrow = styled(RightDoubleArrow)(() => ({
  transform: 'rotate(270deg)',
}))

const UnderDoubleArrow = styled(RightDoubleArrow)(() => ({
  transform: 'rotate(90deg)',
}))

const ArrowTopIosIcon = styled(ArrowForwardIosIcon)(() => ({
  transform: 'rotate(270deg)',
}))

const ArrowUnderIosIcon = styled(ArrowForwardIosIcon)(() => ({
  transform: 'rotate(90deg)',
}))

type Handler = MouseEventHandler<HTMLButtonElement>
interface Props {
  onOneUpClick: Handler
  onOneDownClick: Handler
  onTopClick: Handler
  onBottomClick: Handler
  disabled: boolean
  onDocumentTypeOneUpClick: Handler
  onDocumentTypeOneDownClick: Handler
  ducumentTypeHidden?: boolean
  documentTypeMoreThen2?: boolean
}

const OrderController = (props: Props) => {
  const {
    onOneUpClick,
    onOneDownClick,
    onTopClick,
    onBottomClick,
    disabled,
    onDocumentTypeOneUpClick,
    onDocumentTypeOneDownClick,
    ducumentTypeHidden,
    documentTypeMoreThen2,
  } = props

  return (
    <Box display="flex" flexDirection="column" style={{ marginLeft: 10 }}>
      <MyTypography variant="caption" align="center">
        順序変更
      </MyTypography>
      <Card variant="outlined">
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
          <MyTypography variant="caption">項目</MyTypography>
          <MyButton onClick={onTopClick} disabled={disabled} data-testid="on-top">
            <TopDoubleArrow />
            <Typography variant="caption">一番上</Typography>
          </MyButton>
          <MyButton onClick={onOneUpClick} disabled={disabled} data-testid="on-one-up">
            <ArrowTopIosIcon />
            <Typography variant="caption">一つ上</Typography>
          </MyButton>
          <MyButton onClick={onOneDownClick} disabled={disabled} data-testid="on-one-down">
            <ArrowUnderIosIcon />
            <Typography variant="caption">一つ下</Typography>
          </MyButton>
          <MyButton onClick={onBottomClick} disabled={disabled} data-testid="on-bottom">
            <UnderDoubleArrow />
            <Typography variant="caption">一番下</Typography>
          </MyButton>
        </Box>
        {!ducumentTypeHidden && (
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <MyTypography variant="caption">文書種別</MyTypography>
            <MyButton
              onClick={onDocumentTypeOneUpClick}
              disabled={!documentTypeMoreThen2 || disabled}
              data-testid="on-doctype-one-up"
            >
              <ArrowTopIosIcon />
              <Typography variant="caption">一つ上</Typography>
            </MyButton>
            <MyButton
              onClick={onDocumentTypeOneDownClick}
              disabled={!documentTypeMoreThen2 || disabled}
              data-testid="on-doctype-one-down"
            >
              <ArrowUnderIosIcon />
              <Typography variant="caption">一つ下</Typography>
            </MyButton>
          </Box>
        )}
      </Card>
    </Box>
  )
}

export default OrderController
